import React, {useEffect, useMemo, useState} from "react";
import {FormControl} from "react-bootstrap";
import {formatDurationFromTimeSpan, parseTimeSpan} from "../../../../utils/DateTimeUtills";
import {useTranslation} from "react-i18next";

const TimespanInput = ({ value, setValue, setNewValue, constraints, onValidChange }) => {
    const { t } = useTranslation();
    const [isValid, setIsValid] = useState(true);

    // Memoize the parsed timespan to avoid redundant computations
    const timeSpan = useMemo(() => parseTimeSpan(value), [value]);

    // Helper function to check validity
    const isValidTimeSpan = useMemo(() => {
        return timeSpan !== null && (!constraints || timeSpan.totalSeconds <= constraints.maxValue);
    }, [timeSpan, constraints]);

    // Effect to handle validation changes
    useEffect(() => {
        if (isValidTimeSpan !== isValid) {
            onValidChange?.(isValidTimeSpan);
            setIsValid(isValidTimeSpan);
        }
    }, [isValidTimeSpan]);

    // Handle input changes
    const handleValueChange = (e) => {
        const sanitizedValue = e.target.value.replace(/[^0-9:.]/g, ""); // Remove invalid characters
        setValue(sanitizedValue);
        setNewValue(sanitizedValue);
    };

    return (
        <div className="d-flex flex-column align-items-center w-100">
            <small className={`smallText user-select-none ${isValid ? "" : "text-danger"}`}>
                {formatDurationFromTimeSpan(timeSpan, t)}
            </small>
            <FormControl className="w-100 mt-1" type="text" value={value} onChange={handleValueChange} />
        </div>
    );
};

export default TimespanInput;
